// extracted by mini-css-extract-plugin
export default {"layout":"ff5c3c8db5 e7e045c0eb _3c66ead091","h_slide":"d983068835","category":"_9e6dbd1549 _0332c8a4d6 _7a373f0024"};